<script lang="jsx">
import { calculateTreeDepth } from './func'
import _ from 'lodash'
export default {
  name: 'UmTableRoleMain',
  components: { },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    treeData: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showHead: {
      type: Boolean,
      default: false
    },
    tableName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      tableId: '',
      dataMap: {}, // ID 和 对象的关联关系
      treeDeep: 0, // 树深度
      flatData: [], // 树平级数据
      tableHead: {
        sysModuleName: '',
        sysModuleCode: ''
      }
    }
  },
  computed: {},
  watch: {
    treeData: {
      handler(tree) {
        if (Array.isArray(tree) && tree.length) {
          this.treeDeep = calculateTreeDepth(tree)
          this.tableId = `roleTable${tree[0].sysModuleCode}`
          this.tableHead = { sysModuleCode: tree[0].sysModuleCode, sysModuleName: tree[0].sysModuleName }
          this.initData(tree)
        }
      },
      immediate: true
    }
  },
  created() {},
  methods: {
    initData(tree) {
      const treeData = _.cloneDeep(tree)
      // 初始化树数据，渲染表格
      const mapData = {}
      function handleTreeData(list) {
        list.forEach((item) => {
          const children = item.children || []
          const isLeaf = children.every(i => !i.children || i.children.length === 0)
          if (isLeaf) {
            item.list = children
            item.children = []
            children.forEach(i => {
              mapData[i.sysModuleCode] = i
            })
          } else {
            handleTreeData(children)
          }
          mapData[item.sysModuleCode] = item
        })
      }
      handleTreeData(treeData)
      this.dataMap = mapData
      let deep = 0 // 树深度
      function calculateTreeMerge(list, _deep = 0, _parent = null) {
        // 计算单元格合并
        deep = Math.max(deep, _deep + 1)
        let length = 0
        list.forEach((item) => {
          if (item.children && item.children.length) {
            item.rowspan = calculateTreeMerge(item.children, _deep + 1, item)
            item.colspan = 1
            length += item.rowspan
          } else {
            item.rowspan = 1
            item.colspan = 1
            length += 1
          }
          if (item.list && item.list.length) {
            // 处理最底层的父子关系
            calculateTreeMerge(item.list, _deep + 1, item)
          }
          item.deep = _deep
          item.$_parent = _parent
        })
        return length
      }
      calculateTreeMerge(treeData)
      const deepList = new Array(deep).fill(0)
      const flatData = []
      function loopData(list) {
        list.forEach((item) => {
          const _deep = item.deep
          const row = deepList[_deep]
          deepList[_deep] += item.rowspan
          // 如果当前子项的深度小于整体深度，且没有子集了，那么把缺少的深度行数，补充成当前行一致
          if (_deep < deep && (item.children && item.children.length === 0)) {
            for (let i = _deep; i < deep; i++) {
              deepList[i] = deepList[_deep]
            }
          }
          if (item.children && item.children.length) {
            loopData(item.children)
          }
          if (!flatData[row]) {
            flatData[row] = []
          }
          flatData[row][_deep] = item
        })
      }
      loopData(treeData)
      this.flatData = flatData
    },
    getCheckData() {
      // 获取选中的数据
      const roleData = []
      Object.keys(this.dataMap).forEach(key => {
        if (this.dataMap[key].checked || this.dataMap[key].indeterminate) {
          roleData.push(this.dataMap[key].sysModuleCode)
        }
      })
      return roleData
    },
    changeCode(checked, item) {
      item.checked = checked
      this.$set(item, 'indeterminate', false)
      this.setChildrenChecked(item, checked)
      this.setPatentChecked(item.$_parent, checked)
    },
    setPatentChecked(_parent, _checked) {
      if (!_parent) return false
      let checked = false
      if (_parent.children && _parent.children.length) {
        checked = _parent.children.every(i => i.checked)
      }
      if (_parent.list && _parent.list.length) {
        checked = _parent.list.every(i => i.checked)
      }
      _parent.checked = checked
      if (checked) {
        this.$set(_parent, 'indeterminate', false)
      } else {
        // 1、子集是否存在被选中、子集未被选中
        const indeterminate = _parent.children.some(i => i.checked || i.indeterminate) || _parent.list?.some(i => i.checked)
        this.$set(_parent, 'indeterminate', indeterminate)
      }
      this.setPatentChecked(_parent.$_parent, checked)
    },
    setChildrenChecked(data, checked) {
      if (data.children) {
        data.children.forEach(i => {
          if (i.readOnly === 0) {
            // 权限在非只读状态下可被操作
            i.checked = checked
          }
          i.indeterminate = false
          this.setChildrenChecked(i, checked)
        })
      }
      if (data.list) {
        data.list.forEach((i) => {
          if (i.readOnly === 0) {
            // 权限在非只读状态下可被操作
            i.checked = checked
          }
          this.setChildrenChecked(i, checked)
        })
      }
    }
  },
  render(h, context) {
    const data = this.flatData
    const deep = this.treeDeep
    const nodes = []
    for (let i = 0; i < data.length; i++) {
      const td_list = []
      for (let j = 0; j < deep; j++) {
        if (data[i][j]) {
          td_list.push(
            <td rowSpan={data[i][j].rowspan} colSpan={data[i][j].list ? (deep - data[i][j].deep) : 1}>
              <el-checkbox
                value={data[i][j].checked}
                indeterminate={data[i][j].indeterminate}
                true-label={1} false-label={0}
                disabled={Boolean(this.disabled || data[i][j].readOnly)}
                on={{ change: (checked) => this.changeCode(checked, data[i][j]) }}
              >
                {data[i][j].sysModuleName}
              </el-checkbox>
            </td>
          )
          if (data[i][j].list) {
            const list = data[i][j].list.map(o => {
              return <el-checkbox true-label={1} false-label={0} disabled={Boolean(this.disabled || o.readOnly)} value={o.checked} on={{ change: (checked) => this.changeCode(checked, o) }}>{o.sysModuleName}</el-checkbox>
            })
            td_list.push(<td colSpan={deep - data[i][j].deep}>{list}</td>)
          }
        }
      }
      nodes.push(<tr>{td_list}</tr>)
    }
    return (
      <div>
        {
          this.showHead ? <div class="role-table-head">{ this.tableName ? this.tableName : this.tableHead.sysModuleName }</div> : ''
        }
        {
          nodes.length ? <table class="role-table">{nodes}</table> : <div class="empty-role"><el-empty description="暂无权限数据"/></div>
        }
      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
.role-table{
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
}
.role-table tr,td{
  border: 1px solid #ccc;
  padding:5px 10px;
  min-width: 100px;
}
.role-table-head{
  background: #f8fafb;
  padding:5px 10px;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-top: 1px solid #ccc;
}
.empty-role{
  border: 1px solid #ccc;
}
</style>
